const BetHistory = () => import(/* webpackPrefetch: true, webpackChunkName: 'order' */ 'wap/views/order/betHistory/index.vue')
const OrderDetail = () => import(/* webpackPrefetch: true, webpackChunkName: 'order' */ 'wap/views/order/orderDetail/App.vue')
const BetDetail = () => import(/* webpackPrefetch: true, webpackChunkName: 'order' */ 'wap/views/order/betDetail/App.vue')
const Cashout = () => import(/* webpackPrefetch: true, webpackChunkName: 'order' */ 'wap/views/myBets/App.vue')

const routes = [
  // bet history
  {
    path: '/my_bets/history/archived',
    alias: '/my_bets/history/bf6m',
    name: 'beforeBetHistory',
    component: BetHistory,
    props: () => ({ type: 'history' }),
    meta: {
      enableTheme: true
    }
  },
  {
    path: '/my_bets/history/deleted',
    name: 'deletedBetHistory',
    component: BetHistory,
    props: () => ({ type: 'deleted' })
  },
  {
    path: '/my_bets/history',
    name: 'betHistory',
    component: BetHistory,
    meta: {
      title: 'Sports Bet History | My Bets | MSport',
      enableTheme: true
    }
  },
  // ticket detail
  {
    path: '/my_bets/order_info',
    name: 'orderDetail',
    component: OrderDetail,
    props: (route) => ({ orderId: route.query.id }),
    meta: {
      title: 'Ticket Details | My Bets | MSport',
      enableTheme: true
    }
  },
  // bet detail
  {
    path: '/my_bets/bet_info',
    name: 'betDetail',
    component: BetDetail,
    props: (route) => ({ orderId: route.query.id }),
    meta: {
      title: 'Bet Details | My Bets | MSport',
      enableTheme: true
    }
  },

  // my bets
  {
    path: '/my_bets/cashout',
    name: 'cashout',
    component: Cashout,
    meta: {
      // 无 user 订阅推送
      noPush: true,
      title: 'My Bets | MSport',
      enableTheme: true
    }
  }
]

export default routes
